export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SSO = 'LOGIN_USER_SSO';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'; 
export const UPDATE_FEATURE_SUCCESS = 'UPDATE_FEATURE_SUCCESS'; 

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const API_ERROR = 'LOGIN_API_ERROR';
